import { Space, TextLoader } from '@procurify/ui'

export const SlackIntegrationSectionLoader = () => {
  return (
    <Space direction='vertical'>
      <TextLoader width={400} />
      <TextLoader width={400} />
      <TextLoader width={400} />
    </Space>
  )
}
